import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import { useTranslation } from 'react-i18next';
import { countriesFactory, locatorCountriesFactory } from 'utils/factories/countries';

export const useCountries = () => {
  const api = useApi();

  const {
    i18n: { language: locale },
  } = useTranslation();

  const queryParams = { itemsPerPage: 300, locale };

  return useQuery({
    queryKey: countriesFactory.list(queryParams),
    queryFn: async () => api.countries.apiCountriesGetCollection(queryParams),
    select: (res) => res?.data['hydra:member'],
  });
};

export const useLocatorCountries = () => {
  const api = useApi();

  const {
    i18n: { language: locale },
  } = useTranslation();

  return useQuery({
    queryKey: locatorCountriesFactory.list({ locale }),
    queryFn: () => api.countries.apiCountrieslocatorGetCollection({ locale }),
    select: (res) => res?.data['hydra:member'],
  });
};
